import "../styles/Legal.css";

export default function CookiesPolicy() {
  return (
    <div className="legal-page">
      <h1>Cookie-politika</h1>

      <p>
        Webgune honek bere funtzionamendurako beharrezkoak diren cookie teknikoak
        erabiltzen ditu.
      </p>

      <h2>Zer dira cookie-ak</h2>
      <p>
        Cookie-ak erabiltzailearen gailuan gordetzen diren fitxategi txikiak dira
        webgune bat bisitatzean. Haien helburua webgunearen funtzionamendua
        erraztea eta, kasu batzuetan, erabiltzailearen hobespen edo saioari
        buruzko informazioa gordetzea da.
      </p>

      <h2>Zer cookie mota erabiltzen dira webgune honetan</h2>
      <ul>
        <li>
          <strong>Cookie teknikoak:</strong> webguneak behar bezala
          funtzionatzeko ezinbestekoak direnak.
        </li>
        <li>
          <strong>Saio-cookieak:</strong> administrazio guneko saioa kudeatzeko
          erabiltzen direnak, baimendutako erabiltzaileek modu seguruan sartu
          ahal izan dezaten.
        </li>
      </ul>

      <h2>Erabilitako cookien helburua</h2>
      <p>Webgune honetako cookieak honako helburu hauetarako erabiltzen dira:</p>
      <ul>
        <li>Nabigazioa eta webgunearen oinarrizko funtzionamendua ahalbidetzea</li>
        <li>Administrazio guneko autentifikazioa eta saioa kudeatzea</li>
        <li>Webgunearen segurtasuna eta egonkortasuna bermatzea</li>
      </ul>

      <h2>Hirugarrenen cookieak</h2>
      <p>
        Webgune honek ez du Google Analytics edo antzeko analitika zerbitzurik
        erabiltzen. Ondorioz, ez dira analisi-cookieak edo publizitate-cookieak
        erabiltzen, salbu eta etorkizunean zerbitzu berriak txertatzen badira eta
        politika hau eguneratzen bada.
      </p>

      <h2>Cookieen kudeaketa</h2>
      <p>
        Erabiltzaileak bere nabigatzailea konfiguratu dezake cookieak blokeatzeko
        edo ezabatzeko. Hala ere, cookie teknikoak desgaituz gero, baliteke
        webgunearen zati batzuk behar bezala ez ibiltzea, bereziki administrazio
        guneko sarbidea.
      </p>

      <h2>Onarpena</h2>
      <p>
        Webgune honen erabilerak funtzionamendurako beharrezkoak diren cookie
        teknikoen erabilera onartzea dakar.
      </p>

      <h2>Politikaren eguneraketak</h2>
      <p>
        Alaiak Mungialdeko Soinulari Elkarteak cookie-politika hau eguneratzeko
        eskubidea gordetzen du, webgunean egin daitezkeen aldaketen edo legezko
        betebeharren arabera.
      </p>
    </div>
  );
}